import { environment } from '../../environments/environment';

const FALLBACK_APP_VERSION = 'v1.0.0';

/**
 * Versão exibida no painel. Configure `appVersion` em `environment*.ts`.
 * Se ausente ou vazio, usa FALLBACK_APP_VERSION.
 */
export function getAppVersion(): string {
    const raw = (environment as { appVersion?: string }).appVersion;
    if (raw == null) {
        return FALLBACK_APP_VERSION;
    }
    const trimmed = String(raw).trim();
    return trimmed === '' ? FALLBACK_APP_VERSION : trimmed;
}

export const APP_VERSION = getAppVersion();



// WEBPACK FOOTER //
// ./src/app/constants/app-version.ts